import React from 'react';

import { DashboardSessionsContentAll } from './all-sessions';
import useDashboardActiveTab from '../helpers/active-tab.hook';
import { useCurrentSubscription } from 'src/store/subscription';
import { useFeatureRestrictions } from 'src/hooks/useFeatureRestrictions';
import { FixedLoadingSpinner } from 'src/common/components/loading-spinner';
import OrganizationLink from 'src/common/OrganizationLink';


type DashboardInsightsPropsInterface = {
  activeListType: string;
};

export const DashboardSessionHome = ({ activeListType }: DashboardInsightsPropsInterface) => {
  useDashboardActiveTab('sessions');

  const { subscriptionLoading } = useCurrentSubscription();
  const { features, showUpgradeModal } = useFeatureRestrictions();

  const handleUpgradeClick = () => {
    showUpgradeModal('session_replay', 
      'Session replay is a reconstructed presentation of how a user interacted with your journeys. It captures mouse clicks, movements etc giving you deeper insights.<br/><br/>To unlock session replays, upgrade to the Scale Plan',
      'Unlock Session Replay'
    );
  };

  return (
    <>
      <div className='flex flex-col w-full'>
        <div className='text-bedrock-serif-h1'>Session Replays</div>
        
        {subscriptionLoading ? (
          <FixedLoadingSpinner/>
        ) : features.canAccessSessionReplay ? (
          <div className='flex flex-col mt-6'>
            <DashboardSessionsContentAll />
          </div>
        ) : (
          <div className='mt-10'>
            <span className='text-neue-journey-medium mb-5'>Upgrade to Scale plan to access session replays</span>
            <img 
              className="mt-3 rounded-md border border-gray-800" 
              src={"https://dashboardcdn.journey.io/dashboard-images/session-recording.png"} 
              width={553} 
              height={398} 
              alt={'Session-Replays'} 
            />
               <div className='mt-4'>
              <OrganizationLink
               to={`/billing`}
                className='btn-bedrock-primary'
              >
                Upgrade to Scale Plan
              </OrganizationLink>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
